import { ArrowUpRight } from "lucide-react";

const ITEMS = [
  "Digital Acquisition Funnels",
  "Paid Media & Programmatic",
  "SEO & Content Architecture",
  "AI Marketing Automation",
  "Salesforce CRM Pipelines",
  "Predictive Lead Scoring",
  "Commercial Market Assessment",
  "Conversion Rate Optimization",
];

export default function Marquee() {
  return (
    <div className="marquee-mask relative overflow-hidden border-y hairline bg-surface/40 py-5" data-testid="services-marquee">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
            {ITEMS.map((it) => (
              <span
                key={`${dup}-${it}`}
                className="flex items-center gap-6 px-6 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500"
              >
                {it}
                <ArrowUpRight className="h-3.5 w-3.5 text-neon/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
